import { RefObject, useEffect } from "react";

interface UseViewportDetectorProps {
  targetRef: RefObject<HTMLDivElement>;
  rootRef: RefObject<HTMLDivElement>;
  onIntersect: () => void;
  threshold?: number;
  rootMargin?: string;
  enabled?: boolean;
  isFirstLoad?: boolean;
}

export const useViewportDetector = ({
  targetRef,
  rootRef,
  onIntersect,
  threshold = 0.1,
  rootMargin = "0px",
  enabled = true,
  isFirstLoad,
}: UseViewportDetectorProps) => {
  useEffect(() => {
    if (!enabled) return;

    const options = {
      root: rootRef.current,
      rootMargin,
      threshold,
    };

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        onIntersect();
      }
    };

    const observer = new IntersectionObserver(handleIntersect, options);

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => observer.disconnect();
  }, [targetRef, rootRef, onIntersect, threshold, rootMargin, enabled]);
};
